<script setup lang="ts">
import { computed, ref } from 'vue';

import NoticesStatusBadge from '@/components/badges/NoticesStatusBadge.vue';
import AppBarBtn from '@/components/btns/AppBarBtn.vue';
import NoticesMenuCard from '@/components/cards/NoticesMenuCard.vue';
import AppBarBtnWrapper from '@/components/wrappers/AppBarBtnWrapper.vue';
import { useStore } from '@/store';

const store = useStore();

const notifications = computed(
  () => store.state.moduleNotifications.notifications,
);

const menu = ref(false);

function closeMenu(): void {
  menu.value = false;
}
</script>

<template>
  <v-menu
    v-model="menu"
    eager
    :close-on-content-click="false"
    transition="slide-y-transition"
    :class="$style.noticesBarVMenu"
    :content-class="$style.content"
    data-testid="noticesBarVMenu"
  >
    <template #activator="{ props: menuProps }">
      <AppBarBtnWrapper>
        <AppBarBtn icon="mdi-bell-outline" v-bind="menuProps" />
        <NoticesStatusBadge
          v-if="
            notifications.loading ||
            notifications.error ||
            notifications.counter_unread
          "
          :class="$style.counter"
          :is-loading="notifications.loading"
          :is-error="!!notifications.error"
          :counter="notifications.counter_unread"
        />
      </AppBarBtnWrapper>
    </template>
    <NoticesMenuCard :close-menu="closeMenu" />
  </v-menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.noticesBarVMenu {
}
  .counter {
    position: absolute;
    margin-left: 20px;
    margin-top: -18px;
  }

.content {
  right: variables.$pageMarginX;
  left: auto !important;
}
</style>
